module.exports = {"title":"Hub Settings","global_settings_title":"Global Settings","datatable":{"global_settings_action":"Global Settings","name":"Name","outlets":"Stations"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/hub_settings.php
// module id = lbSx
// module chunks = 99